import template from './index.html'

const toggle = (params) => {
  return {
    id: params.id,
    onText: params.onText || 'ON',
    offText: params.offText || 'OFF',
    checked: params.checked != undefined ? params.checked : true,
    onChange() {
      if (params.onChange) params.onChange(this.checked)
    },
    async init() {
        this.$nextTick(_ => {
          this.$el.innerHTML = template
        })
    }
  }
}

export { toggle };
